import React, { useEffect, useState } from "react";

import { currentUser, getAutoSSOUrl } from "@quintype/bridgekeeper-js";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { DfpComponent } from "../../ads/dfp-component";
import { MEMBER_UPDATED } from "../../store/actions";
import { TopBar } from "./top-bar";

import get from "lodash/get";
import { BrowserView, MobileView } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { getCookie } from "../../utils";

import "./Header.m.css";

const Header = () => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const currentPath = qtState.currentPath;
  const pageType = qtState.pageType;
  const isAdfree = get(qtState, ["config", "subscriber"]) === "true";
  let headerSlotConfig = get(qtState, ["config", "ads-config", "ad_slots", pageType], {});
  const dfpAdsConfig = get(qtState, ["config", "ads-config", "dfp_ads"], {});
  if (pageType === "story-page" && qtState?.data?.story?.["story-template"] !== "text") {
    headerSlotConfig = get(qtState, ["config", "ads-config", "ad_slots", qtState?.data?.story?.["story-template"]], {});
  } else if (qtState?.data?.section?.slug.includes("photos")) {
    headerSlotConfig = get(qtState, ["config", "ads-config", "ad_slots", "photo-listing"], {});
  } else if (qtState?.data?.section?.slug.includes("videos")) {
    headerSlotConfig = get(qtState, ["config", "ads-config", "ad_slots", "video-listing"], {});
  } else if (qtState?.data?.section?.slug.includes("visual-stories")) {
    headerSlotConfig = get(qtState, ["config", "ads-config", "ad_slots", "visual-stories"], {});
  }
  const networkId = get(qtState, ["config", "ads-config", "network_id"], {});
  const [adComponent, setAdComponent] = useState();
  const [showOneTap, setShowOneTap] = useState(false);
  const dispatch = useDispatch();
  const getState = useSelector((state) => state);
  const publisherAttributes = get(getState, ["qt", "config", "publisher-attributes"], {});
  const isAutoSSOEnabled = get(publisherAttributes, ["auto_sso", "is_enable"], false);
  const clientId = get(publisherAttributes, ["sso_login", "client_id"], "");
  const redirectUrl = get(publisherAttributes, ["sso_login", "redirect_Url"], "");
  const is1x1Enabled = get(dfpAdsConfig, ["enable_1x1"], true);
  const isIntrestitalEnabled = get(dfpAdsConfig, ["enable_intrestital"], true);
  const isWebView = get(qtState, ["config", "isWebView"]) === true;
  const GoogleClientId = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "google_client_id"], "")
  );

  const getCurrentUser = async () => {
    try {
      const currentUserResp = await currentUser();
      if (!currentUserResp || !currentUserResp.user) {
        setShowOneTap(true);
      } else {
        setShowOneTap(false);
      }
      dispatch({ type: MEMBER_UPDATED, member: get(currentUserResp, ["user"], null) });
      return currentUserResp;
    } catch (err) {
      console.error("something went wrong", err);
      setShowOneTap(true);
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const queryParamExists = queryParams.has("logged_in");

    getCurrentUser().then(({ user }) => {
      if (isAutoSSOEnabled && !user && !queryParamExists) {
        const autoSsoUrl = getAutoSSOUrl(clientId, redirectUrl, window.location.href);
        window.location.replace(autoSsoUrl);
      }
    });
  }, []);

  useEffect(() => {
    const desktopAdUnit = get(headerSlotConfig, ["desktop", "above_header", "ad_unit"], "");
    const mobileAdUnit = get(headerSlotConfig, ["mobile", "above_header", "ad_unit"], "");
    const desktop1x1 = get(headerSlotConfig, ["desktop", "1x1", "ad_unit"], "");
    const desktop1x1_1 = get(headerSlotConfig, ["desktop", "1x1_1", "ad_unit"], "");
    const mobile1x1 = get(headerSlotConfig, ["mobile", "1x1", "ad_unit"], "");
    const mobile1x1_1 = get(headerSlotConfig, ["mobile", "1x1_1", "ad_unit"], "");
    const desktopIntrestital = get(headerSlotConfig, ["desktop", "intrestital", "ad_unit"], "");
    const mobileIntrestital = get(headerSlotConfig, ["mobile", "intrestital", "ad_unit"], "");
    setAdComponent(
      <>
        {desktopAdUnit && (
          <BrowserView>
            <DfpComponent
              adStyleName="ad-slot-size-728x90-320x50"
              id={`${pageType}-header-leaderboard`}
              path={`/${networkId}/${desktopAdUnit}`}
              adSlotConfigName="leaderboard_ad"
              showText={false}
            />
          </BrowserView>
        )}
        {mobileAdUnit && (
          <MobileView>
            <DfpComponent
              adStyleName="ad-slot-size-728x90-320x50"
              id={`${pageType}-header-leaderboard-mobile`}
              path={`/${networkId}/${mobileAdUnit}`}
              adSlotConfigName="320x50_ad"
              showText={false}
            />
          </MobileView>
        )}
        {is1x1Enabled && desktop1x1 && (
          <BrowserView>
            <DfpComponent
              id={`${pageType}-header-1x1`}
              path={`/${networkId}/${desktop1x1}`}
              adSlotConfigName="1x1_ad"
              outOfPage={false}
              showText={false}
              lazyLoadRefreshAdUnit={false}
              noDivWrap={true}
            />
            </BrowserView>
            )}
        {is1x1Enabled && desktop1x1_1 && (
          <BrowserView>
            <DfpComponent
              id={`${pageType}-header-1x1_1`}
              path={`/${networkId}/${desktop1x1_1}`}
              adSlotConfigName="1x1_ad"
              outOfPage={false}
              showText={false}
              lazyLoadRefreshAdUnit={false}
              noDivWrap={true}
            />
          </BrowserView>
        )}
        {is1x1Enabled && mobile1x1 && (
          <MobileView>
            <DfpComponent
              id={`${pageType}-header-1x1-mobile`}
              path={`/${networkId}/${mobile1x1}`}
              adSlotConfigName="1x1_ad"
              outOfPage={false}
              showText={false}
              lazyLoadRefreshAdUnit={false}
              noDivWrap={true}
            />
            </MobileView>
            )}
            {is1x1Enabled && mobile1x1_1 && (
          <MobileView>
            <DfpComponent
              id={`${pageType}-header-1x1-mobile_1`}
              path={`/${networkId}/${mobile1x1_1}`}
              adSlotConfigName="1x1_ad"
              outOfPage={false}
              showText={false}
              lazyLoadRefreshAdUnit={false}
              noDivWrap={true}
            />
          </MobileView>
        )}
        {isIntrestitalEnabled && desktopIntrestital && (
          <BrowserView>
            <DfpComponent
              id={`${pageType}-header-intrestital`}
              path={`/${networkId}/${desktopIntrestital}`}
              outOfPage={false}
              showText={false}
              lazyLoadRefreshAdUnit={false}
              noDivWrap={true}
              adSlotConfigName="1x1_ad"
              adStyleName="ad-style-intrestital"
            />
          </BrowserView>
        )}
        {isIntrestitalEnabled && mobileIntrestital && (
          <MobileView>
            <DfpComponent
              id={`${pageType}-header-intrestital-mobile`}
              path={`/${networkId}/${mobileIntrestital}`}
              outOfPage={false}
              showText={false}
              lazyLoadRefreshAdUnit={false}
              noDivWrap={true}
              adSlotConfigName="1x1_ad"
              adStyleName="ad-style-intrestital"
            />
          </MobileView>
        )}
      </>
    );
  }, [isAdfree]);

  useEffect(() => {
    if (pageType === "summary-page" && typeof window !== "undefined") {
      document.body.style.overscrollBehaviorY = "none";
    }
  }, []);

  const member = useSelector((state) => get(state, ["member"], null));
  useEffect(() => {
    if (member && pageType !== "story-page") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "dl_user_info",
        login_status: "logged-in",
        user_id: `${member.id}`,
        subscription_status: "not-subscribed",
      });
    }
    const qtAuthCookie = getCookie("qt-auth");
    if (member && qtAuthCookie) {
      window.location.href = window.location.pathname + window.location.search;
    }
  }, [member, currentPath]);

  if (isWebView) {
    return (
      <GoogleOAuthProvider clientId={GoogleClientId}>
        <></>
      </GoogleOAuthProvider>
    );
  }

  return (
    <GoogleOAuthProvider clientId={GoogleClientId}>
      {isAdfree ? (
        <div>
          <TopBar showOneTap={showOneTap} />
        </div>
      ) : (
        <div styleName="ad-wrapper">
          {adComponent}
          <TopBar showOneTap={showOneTap} />
        </div>
      )}
    </GoogleOAuthProvider>
  );
};

export { Header };
